<template>
	<div class="card">
		<div class="card-header bg-danger header-elements-inline">
		<h5 class="card-title"><i class="fa fa-lg fa-exclamation"></i> Error</h5>
		</div>
		<div class="card-body font-weight-bold">
		{{ message }}
		</div>
	</div>
</template>
<script>
export default {
	name: "Error",
	props: [ 'message' ]
}
</script>
